import { render } from "./shareCollectionCourse.vue?vue&type=template&id=08313dbc&scoped=true"
import script from "./shareCollectionCourse.vue?vue&type=script&lang=js"
export * from "./shareCollectionCourse.vue?vue&type=script&lang=js"

import "./shareCollectionCourse.vue?vue&type=style&index=0&id=08313dbc&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08313dbc"]])

export default __exports__